import { FileTextIcon } from 'lucide-react';

import React from 'react';

import { useTranslation } from '@splitfiesta/i18n';
import { TEXT_LIMITS } from '@splitfiesta/shared';
import { Card, FormTextarea } from '@splitfiesta/ui';

interface ExpenseAdditionalDetailsProps {
  notes: string;
  setNotes: (notes: string) => void;
  totalAmount?: number;
  isLoading?: boolean;
}

export function ExpenseAdditionalDetails({
  notes,
  setNotes,
  totalAmount,
  isLoading = false,
}: ExpenseAdditionalDetailsProps) {
  const { t } = useTranslation();
  const numericAmount = totalAmount || 0;

  return (
    <Card className="space-y-4">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <FileTextIcon className="w-5 h-5 text-gray-600 dark:text-gray-400" />
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            {t('expenses:sections.additionalDetails')}
          </h3>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {t('expenses:descriptions.additionalDetails')}
        </p>
      </div>

      {numericAmount === 0 ? (
        <div className="bg-gray-50 dark:bg-gray-800/50 rounded-lg p-4">
          <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
            {t('expenses:messages.enterAmountToSplit')}
          </p>
        </div>
      ) : (
        <div className="space-y-6">
          {/* Notes */}
          <FormTextarea
            id="notes"
            maxLength={TEXT_LIMITS.EXPENSE_NOTES_MAX}
            label=""
            value={notes}
            onChange={setNotes}
            placeholder={t('expenses:placeholders.notesFriendly')}
            rows={4}
            disabled={isLoading}
            data-testid="expense-notes-input"
          />
        </div>
      )}
    </Card>
  );
}

export default ExpenseAdditionalDetails;
